import { SecureRoute } from '@okta/okta-react';
import React, { FC, useEffect } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { Page } from 'components/molecules/page/page';
import { List } from 'components/organisms/notifications';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { handleLastSeenAtSubscription } from 'stores/notifications/use-pending';

export const Notifications: FC<{
  pending: number;
  resetPending: () => void;
}> = ({ pending, resetPending }) => {
  const { path } = useRouteMatch();

  useEffect(() => {
    handleLastSeenAtSubscription();

    return () => {
      handleLastSeenAtSubscription().unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (pending > 0) {
      resetPending();
    }
  }, [pending, resetPending]);

  return (
    <Page>
      <Page.Header
        sticky
        title={
          <Page.Header.Title>
            {useTranslation('menu.label.all_notifications')}
          </Page.Header.Title>
        }
      />
      <Page.Content>
        <Switch>
          <SecureRoute path={path} exact>
            <List
              pending={pending}
              configScreenUrl={RoutePaths.notificationsSettings}
              resetPending={resetPending}
              isCustomerScreen
            />
          </SecureRoute>
          <SecureRoute path="*">404 not found</SecureRoute>
        </Switch>
      </Page.Content>
    </Page>
  );
};
